<template>
  <div>
    <p class="cm-mg-p-wzd">
      1. {{ $t('boxinspection.basic_data_info') }}
    </p>
    <hr />
    <div>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4">
          <fg-input
            type="text"
            :label="`${$t('common_words.name')}: *`"
            v-model="model.name"
            name="common_words.name"
            v-validate="modelValidations.name"
            :error="getError('common_words.name', true)"
            placeholder="..."
          >
          </fg-input>
        </div>
        <div class="col-12 col-md-6 col-lg-2">
          <fg-input
            type="text"
            :label="`${$t('common_words.abbreviation')}: `"
            v-model="model.abbreviature"
            name="common_words.abbreviation"
            v-validate="modelValidations.abbreviature"
            :error="getError('common_words.abbreviation', true)"
            placeholder="..."
          >
          </fg-input>
        </div>
        <div class="col-12 col-md-6 col-lg-2">
          <fg-input
            type="number"
            min="1"
            max="10000"
            :label="`${$t('common_words.order')}: `"
            v-model="model.order"
            name="common_words.order"
            v-validate="modelValidations.order"
            :error="getError('common_words.order', true)"
          ></fg-input>
        </div>
        <select-component
          :rowClass="`col-12 col-md-6 col-lg-4`"
          :isMultiple="false"
          :dataOptions="types"
          :requireClass="`required-type`"
          @onChange="handleChangeSelected"
          :labelSelect="`${$t('common_words.type')}: *`"
          modelName="type"
          :initialSelection="model.type"
        />
        <div class="col-12">
          <select-businesses-component
            ref="selectBusiness"
            :showLoading="true"
            :requiered="true"
            :initialData="businessesInitial"
            @onChange="updateSelectedBusinesses"
            @showHideLoading="showHideLoading"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  data() {
    return {
      model: {
        id: null,
        name: null,
        abbreviature: null,
        order: null,
        type: null,
        businesses_id: [],
        businesses_names: [],
      },
      modelValidations: {
        name: {
          required: true,
        },
        abbreviature: {
          required: false,
        },
        order: {
          required: false,
          min_value: 1,
          max_value: 10000,
        },
      },
      categories: [],
      businessesInitial: [],
    };
  },

  computed: {
    types() {
      return [
        { id: 'calidad local', name: i18n.t('boxinspection.local_quality') },
        {
          id: 'calidad exterior',
          name: i18n.t('boxinspection.external_quality'),
        },
      ];
    },
  },

  mixins: [MixinPermissions, MixinForm, MixinLoading, MixinValidations],
  methods: {
    validate() {
      return this.$validator
        .validateAll()
        .then((responseInputs) => {
          this.$emit('on-validated', this.model);

          return responseInputs;
        })
        .then((responseSelects) => {
          if (!responseSelects) return responseSelects;
          if (!isset(this.model.type)) {
            return this.validationInputsRequired('type');
          } else if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else return true;
        });
    },
    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { id, name, abbreviature, order, type } = editForm;
      this.model = {
        ...this.model,
        isEdit: true,
        id: id,
        name,
        abbreviature,
        order,
        type,
      };

      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);

      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
<style></style>
